import { Component, OnInit,  OnDestroy, PLATFORM_ID, Inject, ChangeDetectorRef, input, output } from '@angular/core';
import { VerifyResponse } from '../../../models/offers/VerifyResponse';
import { HotelItem } from '../../../models/hotels/HotelItem';
import { TrafficsService } from '../../../services/traffics.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Price } from '../../../models/hotels/Price';
import { AuthGuardService } from '../../../services/auth-guard.service';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptionService } from '../../../services/encyption.service';
import { HotelinfoComponent } from '../../modals/hotelinfo/hotelinfo.component';
import { TvangebotimagevideoComponent } from '../../modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { TVAngebot } from '../../../models/sktv/TVAngebot';
import { AcvisService } from '../../../services/acvis.service';
import { Customer } from '../../../models/customers/Customer';
import { AuthService } from 'src/app/services/auth.service';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FlugDetailComponent } from '@app/components/modals/flugdetail/flugdetail.component';
import { HotelsFilters } from '@app/models/filtermodels/HotelsFilters';
import { isPlatformBrowser } from '@angular/common';
import { MapService } from '@app/services/map.service';
import { CommentComponent } from '../comment/comment.component';
import moment from 'moment';
@Component({
    selector: 'app-offerpackcard',
    templateUrl: './offerpackcard.component.html',
    styleUrls: ['./offerpackcard.component.scss'],
    standalone: false
})
export class OfferpackcardComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    readonly offerid = input<string>(undefined);
    readonly index = input<number>(undefined);
    readonly reference = input<string>(undefined);
    readonly removeFromList = output<string>();
    readonly changeindex = output<any>();
    readonly saveComemnt = output<string>();
    sktvContent: TVAngebot;
    booking: VerifyResponse;
    currentCustomer: Customer;
    totalPrice: Price;
    categoryAr = [];
    hotel: HotelItem;
    offer: any;
    mode: string = '';
    modeText: string = '';
    shareLink: string = '';
    desktopTemplate: string = 'xl';
    firstBilderPos: number = 0;
    firstBilder: string = '';
    showOffer: boolean = true;
    gpsData = [];

    constructor(
        private trafficsService: TrafficsService,
        private acvisService: AcvisService,
        private dialog: MatDialog,
        private router: Router,
        private auth: AuthService,
        private cdr: ChangeDetectorRef,
        private guardService: AuthGuardService,
        private encservice: EncryptionService,
        private authService: AuthGuardService,
        protected mediaObserver: BreakpointObserver,
        protected mapService: MapService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    ngOnInit(): void {
        this.initCustomer()
        this.initMedia();
        this.initMap();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    async initCustomer() {
        this.auth.auth$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    async initMap() {
        if (isPlatformBrowser(this.platformId)) {
            const offerid = this.offerid();
            if (offerid?.length > 0) {
                this.trafficsService.request({ offerid: offerid, partnerid: this.authService.getPartnerId() }, 'offers/getoffersbycode').pipe(
                    takeUntil(this.unsubscribe$)
                ).subscribe(data => {
                    if (!data?.error && data?.statusCode) {
                        this.firstBilder = data.firstBilder ? data.firstBilder : '';
                        this.booking = data as VerifyResponse;
                        if (this.booking?.extra?.orderId?.length > 0) {
                            this.mode = 'sktv' + this.booking.mode
                        } else {
                            this.mode = this.booking.mode;
                        }
                        this.cdr.detectChanges();
                        this.checkMode()
                    }
                });
            }
        }
    }

    async checkMode() {
        switch (this.mode) {
            case 'pauschal':
                this.modeText = 'Pauschal';
                break;
            case 'railtravel':
                this.modeText = 'Bahn + Hotel';
                break;
            case 'hotelonly':
                this.modeText = 'Nur Hotel';
                break;
            case 'flight':
                this.modeText = 'Hin - und Rückflug';
                break;
            case 'oneway':
                this.modeText = 'Nur Hinflug';
                break;
            case 'carrent':
                this.modeText = 'Mietwagen';
                break;

            default:
                this.modeText = '';
                break;
        }
        if (this.mode !== 'carrent') {
            this.initData();
            this.inittotalprice();
        } else {
            this.offer = this.booking.commonOffer;
        }
    }

    async removeFromListF() {
        this.removeFromList.emit(this.offerid());
    }

    async changeindexF(event) {
        this.changeindex.emit(event);
    }

    async initData() {
        if (this.booking) {
            this.offer = this.booking.commonOffer;
            if (this.mode === 'flight' || this.mode === 'oneway') {
                const codes = [];
                if (this.offer?.flightOffer?.flight?.outbound?.legList?.length > 0) {
                    for (let i = 0; i < this.offer.flightOffer.flight.outbound.legList.length; i++) {
                        codes.push(this.offer.flightOffer.flight.outbound.legList[i].departureAirportCode);
                        codes.push(this.offer.flightOffer.flight.outbound.legList[i].arrivalAirportCode);
                    }
                }

                this.acvisService.request({ codes: codes }, 'airoportList').pipe(
                    takeUntil(this.unsubscribe$)
                ).subscribe((res) => {
                    if (res?.length > 0) {
                        for (let i = 0; i < this.offer.flightOffer.flight.outbound.legList.length; i++) {
                            let from;
                            let to;
                            for (let j = 0; j < res.length; j++) {
                                if (this.offer.flightOffer.flight.outbound.legList[i].departureAirportCode === res[j].code) {
                                    from = {
                                        name: res[j].name,
                                        latitude: res[j].latitude,
                                        longitude: res[j].longitude
                                    };
                                }

                                if (this.offer.flightOffer.flight.outbound.legList[i].arrivalAirportCode === res[j].code) {
                                    to = {
                                        name: res[j].name,
                                        latitude: res[j].latitude,
                                        longitude: res[j].longitude
                                    };
                                }
                            }

                            this.gpsData.push({
                                from: from,
                                to: to,
                            });
                        }
                        this.cdr.detectChanges();
                    }
                });
            } else {
                let giata = this.booking.commonOffer?.hotelOffer?.hotel?.giata?.hotelId;
                if (!giata || Number(giata) === 0) {
                    giata = this.booking.commonOffer?.hotelOffer?.hotel?.tourOperator?.code + '_' + this.booking.commonOffer?.hotelOffer?.hotel?.code;
                }
                this.getGiataMedia(giata, this.booking.commonOffer?.hotelOffer?.hotel?.tourOperator?.code);
            }
            const realparams = {
                offerid: this.booking?.offerid
            };
            this.shareLink = this.shareLink = this.router.createUrlTree(['booking'], { queryParams: { params: this.encservice.encrypt(realparams) } }).toString();
            this.cdr.detectChanges();
        }
    }

    async getGiataMedia(giataId, tourOperatorList) {
        if (this.booking?.extra?.orderId?.length > 0) {
            this.acvisService.request({ id: this.booking.extra.orderId }, 'sktvorderdata').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                if (res && !res.error) {
                    this.sktvContent = res as TVAngebot;
                    this.categoryAr = this.sktvContent?.categoryAr?.length > 0 ? this.sktvContent?.categoryAr : [];
                }
                if (this.sktvContent?.images?.length > 0 && this.firstBilder?.length > 0) {
                    this.firstBilderPos = this.sktvContent.images.indexOf(this.firstBilder);
                    this.sktvContent.images = this.changeBilderPos(this.sktvContent.images, this.firstBilderPos);
                }
                this.firstBilderPos = 0;
                this.cdr.detectChanges();
            });
        } else if (giataId?.length > 0) {
            this.trafficsService.request({
                giataId: giataId, tourOperatorList: tourOperatorList, hotelcode: this.booking.commonOffer?.hotelOffer?.hotel?.code,
                hotelcodetour: tourOperatorList + '_' + this.booking.commonOffer?.hotelOffer?.hotel?.code
            }, '/hotels/giataId').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                if (this.booking.commonOffer?.hotelOffer?.hotel) {
                    this.hotel = JSON.parse(JSON.stringify(this.booking.commonOffer?.hotelOffer?.hotel));
                    this.getKeywords();
                    this.hotel.address = res?.hotel?.address;
                    this.hotel.mediaData = res?.hotel?.mediaData;
                    this.hotel.location = res?.hotel?.location;
                    this.hotel.catalogData = res?.hotel?.catalogData;
                    const catg = Number(String(res?.hotel?.category).replace(/,/g, '.'));
                    for (let i = 0; i < Math.floor(catg); i++) {
                        this.categoryAr.push(1);
                    }
                    if (catg > Math.floor(catg)) {
                        this.categoryAr.push(0.5);
                    }
                    for (let i = 0; i < this.hotel?.catalogData?.imageList?.length; i++) {
                        // problem of giata url i25. i30....
                        if (this.firstBilder?.slice(11) === this.hotel.catalogData.imageList[i].slice(11)) {
                            this.firstBilderPos = i;
                            // i = this.hotel.catalogData.imageList.length;
                        }
                        this.hotel.catalogData.imageList[i] = this.hotel.catalogData.imageList[i].replace('size=320', 'size=800').replace('size=180', 'size=800');
                    }
                    if (this.hotel?.catalogData?.imageList?.length > 0 && this.firstBilder?.length > 0) {
                        this.hotel.catalogData.imageList = this.changeBilderPos(this.hotel.catalogData.imageList, this.firstBilderPos);
                    }
                    this.firstBilderPos = 0;
                    this.cdr.detectChanges();
                }
            });
        }
    }

    async getKeywords() {
        // default datas
        const filtersData = {} as HotelsFilters;
        filtersData.adults = '2';
        filtersData.giataIdList = this.hotel?.giata?.hotelId;
        filtersData.navigation = '1, 2';
        filtersData.productType = 'pauschal';
        filtersData.productSubType = 'all';
        filtersData.searchDate = '10,180,7';
        filtersData.rating = {
            source: 'holidaycheck',
            count: 0,
            recommendation: 0,
            overall: 0,
        };
        this.trafficsService.request(filtersData, 'hotels').subscribe((res) => {
            if (res?.hotelList?.length > 0) {
                this.hotel.rating = res.hotelList[0]?.rating;
                this.hotel.keywordList = res.hotelList[0]?.keywordList;
            }
        });
        this.cdr.detectChanges();
    }

    changeBilderPos(targetArray, pos): string[] {
        if (targetArray?.length > 0) {
            targetArray.splice(0, 0, targetArray[pos]);
            targetArray.splice(pos + 1, 1);
        }
        return targetArray;
    }

    async openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: this.hotel,
                images: this.sktvContent?.images?.length > 0 ? this.sktvContent.images : this.hotel.catalogData.imageList,
                videos: this.sktvContent?.video?.length > 0 ? this.sktvContent.video : [],
                current: ev,
                to800: !this.sktvContent,
                desktopTemplate: this.desktopTemplate,
                showSave: true
            }
        }
        const scrollHeight = window.scrollY;
        const resf = this.dialog.open(TvangebotimagevideoComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(() => {
            document.body.style.overflow = '';
            window.scrollTo(0, scrollHeight);
            this.cdr.detectChanges();
        });
    }

    async inittotalprice() {
        let prc = Number(this.booking.totalPrice?.value);
        this.totalPrice = {
            value: this.booking.totalPrice?.value,
            currency: this.booking.totalPrice?.currency
        }
        if (this.booking.insurance?.totalPrice) {
            prc += Number(this.booking.insurance?.totalPrice?.value);
        }
        if (this.booking.carrent?.totalPrice) {
            prc += Number(this.booking.carrent?.totalPrice?.value);
        }
        if (this.booking.parking?.totalPrice) {
            prc += Number(this.booking.parking?.totalPrice?.value);
        }
        this.totalPrice.value = prc + '';
        this.cdr.detectChanges();
    }

    async goToBooking() {
        if (this.booking?.offerid?.length > 0) {
            const realparams = {
                offerid: this.booking?.offerid,
                productType: this.booking?.mode
            };
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(realparams) }
            };
            const url = this.router.createUrlTree(['booking'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    async gotoOffer() {
        if (this.sktvContent?.orderId?.length > 0) {
            this.gotoSktvOffer();
        } else if (this.booking?.offerid?.length > 0 && this.hotel?.giata?.hotelId?.length > 0) {
            let adults = 0;
            const children = [];
            let childrencount = 0;
            for (let i = 0; i < this.booking?.travellerList.length; i++) {
                if (this.booking?.travellerList[i].type === 'H') {
                    adults++;
                } else if (this.booking?.travellerList[i].type === 'K') {
                    childrencount++;
                    children.push({
                        age: this.booking?.travellerList[i].age,
                        children: childrencount
                    });
                }
            }
            let giata = this.booking.commonOffer?.hotelOffer?.hotel?.giata?.hotelId;
            if (!giata || Number(giata) === 0) {
                giata = this.booking.commonOffer?.hotelOffer?.hotel?.tourOperator?.code + '_' + this.booking.commonOffer?.hotelOffer?.hotel?.code;
            }
            const realparams = {
                giataIdList: giata,
                hotelCodeList: this.hotel?.code,
                pauschalreiseResult: {
                    data: {
                        code: giata,
                        name: this.hotel?.giata?.hotelName
                    },
                    type: 1
                },
                reisedauerResult: {
                    name: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration + ' Tage' : 'Beliebig',
                    minDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '1',
                    maxDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '30'
                },
                reisezeitraumResult: {
                    start: new Date(this.booking?.commonOffer?.hotelOffer?.travelDate?.fromDate),
                    end: new Date(this.booking?.commonOffer?.hotelOffer?.travelDate?.toDate),
                    minDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '1',
                    maxDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '30'
                },
                productType: this.booking.mode,
                reisendeResult: {
                    children: children,
                    adults: adults,
                }
            };
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(realparams) }
            };
            const url = this.router.createUrlTree(['offers'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    async gotoSktvOffer() {
        if (this.sktvContent?.orderId?.length > 0) {
            const realparams = {} as ParamFilters;
            const dateFirst = this.sktvContent.depart?.first?.length > 0 ? this.sktvContent.depart.first : '';
            const dateLast = this.sktvContent.depart?.last?.length > 0 ? this.sktvContent.depart.last : '';

            let ddrmin = this.sktvContent?.durationforsearch;
            let ddrmax = ddrmin;
            if (ddrmin === 0) {
                const tmp = this.getDauer(this.sktvContent);
                if (tmp?.length > 0 && !isNaN(Number(tmp)) && Number(tmp) > 2) {
                    ddrmin = Number(tmp) - 2;
                    ddrmax = Number(tmp) + 2;
                } else {
                    ddrmax = 99;
                    ddrmin = 1;
                }
            }

            realparams.reisezeitraumResult = {
                start: moment(dateFirst).format('YYYY-MM-DD'),
                end: moment(dateLast).format('YYYY-MM-DD'),
                minDuration: ddrmin + '',
                maxDuration: ddrmax + '',
            };

            realparams.reisedauerResult = {
                name: ddrmin + '-' + ddrmax + ' Tage',
                minDuration: ddrmin + '',
                maxDuration: ddrmax + '',
            };

            realparams.extra = {
                orderId: this.sktvContent?.orderId,
                seller: this.sktvContent?.organizer
            };

            realparams.reisendeResult = {
                children: [],
                adults: 2,
            };

            realparams.productType = this.sktvContent.producttypeforsearch?.length > 0 ? this.sktvContent.producttypeforsearch : 'pauschal';
            const tmporg = this.sktvContent?.organizer?.split(',');
            const to_code = tmporg?.length > 0 ? tmporg[0] + '_' + this.sktvContent.bookingcode : this.sktvContent.bookingcode;

            realparams.pauschalreiseResult = {
                data: {
                    name: this.sktvContent.name,
                    code: to_code
                },
                type: 1,
            };
            realparams.tourOperatorList = [];
            if (this.sktvContent.organizer?.length > 0) {
                const tmp_ops = this.sktvContent?.organizer?.split(',');
                for (let i = 0; i < tmp_ops?.length; i++) {
                    realparams.tourOperatorList.push({
                        code: tmp_ops[i],
                        name: ''
                    });
                }
            }
            if (this.sktvContent.hidden_op?.length > 0) {
                realparams.tourOperatorList.push({
                    code: this.sktvContent.hidden_op,
                    name: ''
                });
            }
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(realparams) }
            };
            // console.log(realparams);
            this.router.navigate(['offers'], navigationExtras).then(() => {
                window.location.reload();
            });
        }
    }

    async openHotelInfo() {
        if (this.sktvContent) {
            let target = {} as MatDialogConfig;
            if (this.desktopTemplate !== 'xs' && this.desktopTemplate !== 'sm') {
                target = { height: '91vh', width: '80vw', panelClass: 'customModal', data: { sktvContent: this.sktvContent, desktopTemplate: this.desktopTemplate }, autoFocus: false }
            } else {
                target = { width: '100%', height: '100%', maxWidth: '100%', panelClass: 'customModal', data: { sktvContent: this.sktvContent, desktopTemplate: this.desktopTemplate }, autoFocus: false }
            }
            this.dialog.open(HotelinfoComponent, target);
        } else if (this.hotel?.catalogData?.html.length > 0) {
            let target = {} as MatDialogConfig;
            if (this.desktopTemplate !== 'xs' && this.desktopTemplate !== 'sm') {
                target = { height: '91vh', width: '80vw', panelClass: 'customModal', data: { hotel: this.hotel, desktopTemplate: this.desktopTemplate }, autoFocus: false }
            } else {
                target = { width: '100%', height: '100%', maxWidth: '100%', panelClass: 'customModal', data: { hotel: this.hotel, desktopTemplate: this.desktopTemplate }, autoFocus: false }
            }
            this.dialog.open(HotelinfoComponent, target);
        }
    }

    getDauer(dd): string {
        let tmp_d = '';
        if (!isNaN(Number(dd?.duration))) {
            tmp_d = dd?.duration;
        } else if (dd?.duration.indexOf('-tägige') >= 0) {
            tmp_d = dd.duration?.slice(0, dd?.duration.indexOf('-tägige')).trim();
        } else if (dd?.duration.indexOf('Nächte') >= 0) {
            tmp_d = dd.duration?.slice(0, dd?.duration.indexOf('Nächte')).trim();
        }
        return tmp_d;
    }

    async openFluginfo() {
        const target = { data: { offer: this.offer }, autoFocus: false };
        this.dialog.open(FlugDetailComponent, target);
    }

    saveImagesList(pos) {
        this.firstBilderPos = pos;
        let url = '';
        if (this.sktvContent?.images?.length > 0 && this.firstBilderPos > 0) {
            url = this.sktvContent?.images[pos];
        } else if (this.hotel.catalogData.imageList?.length > 0 && this.firstBilderPos > 0) {
            url = this.hotel.catalogData.imageList[pos];
        }
        const target = {
            offerid: this.offerid(),
            firstBilder: url,
            partnerid: this.authService.getPartnerId()
        };
        this.trafficsService.request(target, 'offers/updateImageList').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.error) {
                // console.log(res);
            } else {
                if (this.sktvContent?.images?.length > 0 && this.firstBilderPos > 0) {
                    this.sktvContent.images = this.changeBilderPos(this.sktvContent.images, this.firstBilderPos);
                    this.showOffer = false;
                    this.firstBilderPos = 0;
                    setTimeout(() => {
                        this.showOffer = true;
                    });
                } else if (this.hotel.catalogData.imageList?.length > 0 && this.firstBilderPos > 0) {
                    this.hotel.catalogData.imageList = this.changeBilderPos(this.hotel.catalogData.imageList, this.firstBilderPos);
                    this.showOffer = false;
                    this.firstBilderPos = 0;
                    setTimeout(() => {
                        this.showOffer = true;
                    });
                }
            }
            this.cdr.detectChanges();
        });
    }

    async openSetComment(openmodal) {
        if (openmodal) {
            let target = {} as MatDialogConfig;
            if (this.desktopTemplate !== 'xs' && this.desktopTemplate !== 'sm') {
                target = {
                    width: '600px',
                    data: {
                        title: 'Angebot Nr.' + this.index(),
                        message: this.booking.extracomment
                    },
                    autoFocus: false
                };
            } else {
                target = {
                    width: '100%',
                    height: '100%',
                    maxWidth: '100%',
                    // panelClass: 'customModal',
                    data: {
                        title: 'Angebot Nr.' + this.index(),
                        message: this.booking.extracomment
                    },
                    autoFocus: false
                }
            }
            const resf = this.dialog.open(CommentComponent, target);
            resf.afterClosed().pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((data) => {
                if (data) {
                    this.booking.extracomment = data?.message;
                    this.saveComment(this.booking.extracomment);
                }
                this.cdr.detectChanges();
            });
        }
    }

    saveComment(extracomment) {
        const target = {
            offerid: this.offerid(),
            extracomment: extracomment
        };
        this.trafficsService.request(target, 'offers/saveComment').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.error) {
                console.log(res);
            }
            this.cdr.detectChanges();
        });
    }
}
